const resumeImportMonitor = {
  title: 'Resume Import Liveboard',
  subtitle: 'Track account-wide resume imports, cleaning status, and live activity.',
  windowLabel: 'Window',
  last24Hours: 'Last 24 hours',
  last72Hours: 'Last 72 hours',
  last7Days: 'Last 7 days',
  refresh: 'Refresh',
  liveConnected: 'Live connected',
  liveDisconnected: 'Live disconnected',
  lastEvent: 'Last event {time}',
  totalImported: 'Imported',
  completed: 'Completed',
  processing: 'Processing',
  pending: 'Pending',
  failed: 'Failed',
  activeUsers: 'Users',
  newUsers: 'New Users',
  newUsersNote: 'Registered in window',
  topImporters: 'Import Ranking',
  recentActivities: 'Live Activity',
  latestImports: 'Recent Imports',
  noRanking: 'No ranking data',
  noActivity: 'No live activity',
  unknownCandidate: 'Unknown candidate',
  unknownUser: 'Unknown user',
  importedCount: '{count} resumes',
  completedCount: 'Completed {count}',
  state: {
    Pending: 'Pending',
    Processing: 'Processing',
    Completed: 'Completed',
    Failed: 'Failed',
  },
  action: {
    imported: 'imported',
    pending: 'queued',
    processing: 'started cleaning',
    completed: 'completed cleaning',
    failed: 'failed cleaning',
  },
  activityText: '{candidate} was {action} by {user}',
  streamError: 'Live connection failed. Snapshot data is still available.',
}

export default resumeImportMonitor
